import { render, staticRenderFns } from "./DigitsInput.vue?vue&type=template&id=1721460e&scoped=true&"
import script from "./DigitsInput.vue?vue&type=script&lang=js&"
export * from "./DigitsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1721460e",
  null
  
)

export default component.exports